import Vue from 'vue'
Vue.mixin({
    data() {
        return {
            PRODUCT_LINE_COMMERCIAL: '1',
            PRODUCT_LINE_QHP: '80',
            PRODUCT_LINE_MEDICARE: '30',
            TAB_YOUR_DATA: 0,
            TAB_BENCHMARK: 1,
            TAB_SEGMENT_MEASURE: 2,
            TAB_COHORT: 3
        }
    }
})


    
